import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ScanLine, QrCode, Ticket, Settings as SettingsIcon, Euro } from 'lucide-react';
import { apiFetch } from '../utils/api';


export default function MobileNav() {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkRole = async () => {
      try {
        const response = await apiFetch(`/api/auth/me`);
        if (response.ok) {
          const data = await response.json();
          setIsAdmin(data.role === 'admin');
        }
      } catch (e) { /* ignore */ }
    };
    checkRole();
  }, []);

  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Αρχική' },
    { path: '/entry', icon: ScanLine, label: 'Είσοδος' },
    { path: '/exit', icon: QrCode, label: 'Έξοδος' },
    { path: '/tickets', icon: Ticket, label: 'Εισιτήρια' },
    ...(!isAdmin ? [{ path: '/pricing-view', icon: Euro, label: 'Τιμές' }] : []),
    ...(isAdmin ? [{ path: '/settings', icon: SettingsIcon, label: 'Ρυθμίσεις' }] : []),
  ];

  return (
    <nav className="mobile-nav" data-testid="mobile-navigation">
      {navItems.map(({ path, icon: Icon, label }) => {
        const isActive = location.pathname === path;
        return (
          <Link
            key={path}
            to={path}
            className={`mobile-nav-item ${isActive ? 'active' : ''}`}
            data-testid={`nav-${path.replace('/', '')}`}
          >
            <Icon size={18} strokeWidth={2} />
            <span className="text-[9px] leading-tight">{label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
